import { useEffect } from 'react';
import { useKianPageContext } from '../providers/PageContextProvider';
import type { KianEntityContext } from '../types/kian';

/**
 * Registriert den aktuellen Seitenkontext für KIAN (Flyout).
 * Aufräumen bei Unmount.
 */
export function useRegisterKianContext(ctx: Omit<KianEntityContext, 'visitedAt'> | null) {
  const { register, unregister } = useKianPageContext();

  useEffect(() => {
    if (!ctx) {
      unregister();
      return;
    }
    register(ctx);
    return () => unregister();
  }, [ctx?.type, ctx?.id, ctx?.label, register, unregister]);
}
